import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const XFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function XFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m21.06 5.06-2.12-2.12L12 9.88 5.06 2.94 2.94 5.06 9.88 12l-6.94 6.94 2.12 2.12L12 14.12l6.94 6.94 2.12-2.12L14.12 12l6.94-6.94Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default XFilled;